import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import type { ThemeTokens } from '../styled.d';

interface Theme {
  token: ThemeTokens;
}

interface ThemeProviderProps {
  children: React.ReactNode;
  isDarkMode: boolean;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, isDarkMode }) => {
  const theme: Theme = {
    token: {
      colorPrimary: '#2672be',
      colorBgContainer: isDarkMode ? '#141414' : '#ffffff',
      colorBgContainerDefault: isDarkMode ? '#ffffff' : '',
      colorText: isDarkMode ? '#ffffff' : '#000000',
      colorTextSecondary: isDarkMode ? '#8c8c8c' : '#BDBDBD',
      colorTextTertiary: isDarkMode ? '#8c8c8c' : '#121314',
      colorBorder: isDarkMode ? '#303030' : '#d9d9d9',
      colorBgTextHover: isDarkMode ? '#1f1f1f' : '#f5f5f5',
      colorBgSubtle: isDarkMode ? '#1f1f1f' : '#eeeeee',
    },
  };

  return (
    <StyledThemeProvider theme={theme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;

export const lightTheme = {
  token: {
    colorBgContainer: '#F5F5F5',
    colorText: '#121314',
    colorTextSecondary: '#41474D',
    colorTextTertiary: '#121314',
    colorTextThinking: '#121314',
    colorPrimary: '#1677ff',
    colorBorder: '#E8E8E8',
    colorBgTextHover: '#E8E8E8',
    colorBgSubtle: '#EEEEEE',
    colorIcon: '#737980',
    marginHorizontal: '16px',
  } as ThemeTokens,
};

export const darkTheme = {
  token: {
    colorBgContainer: '#141414',
    colorText: '#FFFFFF',
    colorTextSecondary: '#999999',
    colorTextTertiary: '#999999',
    colorPrimary: '#1677ff',
    colorBorder: '#434343',
    colorBgTextHover: '#1F1F1F',
    colorBgSubtle: '#1F1F1F',
    colorIcon: '#737980',
    marginHorizontal: '16px',
  } as ThemeTokens,
};
